<h1 class="page-title w-50">قطاع الرعاية الصحية
</h1>
<div class="pb-5">
  <div class="d-flex justify-content-between">
    <div class="share-section mb-4 w-50 pt-5">
      <div class="share-text mb-2">شارك المقال على</div>
      <div class="social-icons d-flex justify-content-end gap-2">
        <a href="#" class="social-icon">
          <i class="fa-brands fa-twitter"></i>
        </a>
        <a href="#" class="social-icon">
          <i class="fa-brands fa-facebook-f"></i>
        </a>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="banner-container">
      <img src="../../../assets/Healthcare-banner.jpg" alt=" " class="banner-image" />
      <div class="growth-badge">
        <span> نظام الرعاية الصحية المصري يشهد تحسينات متعددة لضمان صحة ورفاهية الشعب المصري </span>
      </div>
    </div>

    <div class="sector-content">
      <p>قطاع الرعاية الصحية
      </p>
      <hr />
      <p> قطاع الرعاية الصحية: </p>
      <p>
        تُعد مصر أكبر دولة في شمال إفريقيا وتحتل مصر المرتبة 14 في العالم من حيث عدد سكان بما يعادل 1.3٪ من سكان العالم.
        ويساهم السكان الذين ينموا بمعدل متوسط 1.8٪ سنويًا في زيادة الطلب على البنية التحتية والخدمات بما في ذلك الرعاية
        الصحية، مما يؤثر بشكل مباشر على اهمية هذا القطاع في مصر.تدير هذا القطاع هيئتان حكوميتان رئيسيتان وهما وزارة
        الصحة وهيئة التأمين الصحي بينما يتم تقديم الخدمات من قبل قطاعين رئيسيين: الحكومة (القطاع العام) والقطاع الخاص.
        وفي الآونة الأخيرة يشهد نظام الرعاية الصحية المصري تطورات متعددة لضمان توفير الخدامات الصحية وتحقق الرفاهية
        الشعب المصري.تمكن قطاع الرعاية الصحية من تقليل خسائر أزمة انتشار فيروس كورونا من الخلال القيام:§ الصناعة
        التحويلية الراسخة بما في ذلك الشركات المحلية المملوكة للدولة والشركات المحلية الخاصة.§ انخفاض تكاليف العمالة
        ومجموعة كبيرة من الأطباء والصيادلة والمهندسين والفنيين المدربين تدريباً عالياً.§ عدد متزايد من اتفاقيات التجارة
        الحرة وزيادة الإرادة السياسية لتطوير قطاع الرعاية الصحية.§ عوامل ديموغرافية مواتية للغاية.§ مبادرات للنهوض
        بالصحة العامة في مصر، مع التركيز على الإطلاق التدريجي لنظام التأمين الصحي الشامل.§ مقترحات لهيئة الأدوية المصرية
        الجديدة وتسجيل التحسينات على النظام التنظيمي للتنبيه الحيوي.§ يعمل "قانون الاستثمار الجديد" على تحسين بيئة العمل
        للمستثمرين الأجانب.​وزارة الصحة والسكان المصري قامت بوضع خطة عمل لمواجهة فيروس كورونا تنقسم إلى عدت محاور مجالات
        رئيسية:§ إنشاء منافذ تقديم خدمة صحية آمنة تضم 320 مستشفى من المستشفيات العامة والمركزية في مصر، هذا بالإضافة إلى
        قيام المستشفيات المخصصة للحمى وأمراض الصدر. بالإضافة إلى ذلك ستزيد المستشفيات بزيادة قدرات العمل الخاصة بها
        لمواجهة وعلاج الأمراض المزمنة.§ تكوين احتياطي كاف من المستلزمات الطبية والأدوية اللازمة لمواجهة فيروس كورونا.§ ​
        القيام بجراء اختبارات PCR لأي شخص يدخل الدولة للكشف عن الإصابات وعزلها.§​ القيام بتطعيم المواطنين بالعديد من
        أنواع اللاحات للحد من انتشار فيروس كورونا هذا بالإضافة الي إنتاج وتوزيع اللقاحات من خلال الشركة المصرية القابضة
        للمنتجات البيولوجية واللقاحات (VACSERA) بالتعاون مع شركة لقاحات صينية.§ تخصيص مستشفيات الحجر الصحي لمصابي فيروس
        كورونا في كل محافظة. بالإضافة إلى قيام وزارة الصحة بالعمل على ما يلي:· القيام بإرسال سيارات إسعاف ذاتية التعقيم
        لنقل المرضى المصابين الي مستشفيات المخصص للعازل.· العمل على توفير وثاق تامين على الحياة للعاملين في قطاع الرعاية
        الصحية ويتم شراء هذه الوثائق من قبل اتحاد الصناعات المصرية. وتدعم وزارة الصحة بتحديد من هو مؤهل للحصول على هذه
        التغطية بموجب السياسات والشروط التي يتم تحديدها حيث يشمل هذا التامين الموظفين الذين يعملون مباشرة مع مرضى فيروس
        كورونا.

      </p>
      <a href="https://www.investinegypt.gov.eg/Arabic/Pages/exploreMap.aspx?secId=88">لمزيد من المعلومات اضغط هنا</a>
    </div>
  </div>
</div>